import { defineStore } from "pinia";
import { loginTokenWeb, loginWithGoogleIdTokenApi } from "@/api/authApi";

function safeGetLS(key) {
  try {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: safeGetLS("auth_token"),
    user: (() => {
      const raw = safeGetLS("auth_user");
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    })(),
  }),
  getters: {
    isLoggedIn: (s) => !!s.token,
    userId: (s) => s.user?.userId ?? s.user?.id ?? s.user?.data?.userId ?? null,
    userType: (s) => s.user?.userType ?? null,
  },
  actions: {
    _normalize(raw) {
      const payload = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (payload?.status === 400)
        throw new Error(payload?.message || "Login gagal");
      const token = payload?.data?.token ?? payload?.token ?? null;
      const user = payload?.data ?? payload ?? null;
      return { token, user };
    },
    async login(email, password) {
      const raw = await loginTokenWeb(email, password);
      const { token, user } = this._normalize(raw);
      if (!token) throw new Error("Token tidak ditemukan");
      this.token = token;
      this.user = user;
      try {
        localStorage.setItem("auth_token", token);
        localStorage.setItem("auth_user", JSON.stringify(user));
      } catch {
        console.log("");
      }
    },

    async loginWithGoogleIdToken(idToken) {
      const raw = await loginWithGoogleIdTokenApi(idToken);
      const { token, user } = this._normalize(raw);
      if (!token) throw new Error("Token tidak ditemukan");
      this.token = token;
      this.user = user;
      try {
        localStorage.setItem("auth_token", token);
        localStorage.setItem("auth_user", JSON.stringify(user));
      } catch {
        // ignore storage errors
      }
    },
    logout() {
      this.token = null;
      this.user = null;
      try {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
      } catch {
        console.log("");
      }
    },
    hydrateAndListenStorage() {
      try {
        const t = localStorage.getItem("auth_token");
        const u = localStorage.getItem("auth_user");
        this.token = t ?? null;
        this.user = u ? JSON.parse(u) : null;
      } catch {
        console.log("");
      }
      if (typeof window !== "undefined") {
        window.addEventListener("storage", (e) => {
          if (e.key === "auth_token") this.token = e.newValue;
          if (e.key === "auth_user") {
            try {
              this.user = e.newValue ? JSON.parse(e.newValue) : null;
            } catch {
              this.user = null;
            }
          }
        });
      }
    },
  },
});
